import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ArrowUpRight, Menu, X, MapPin, Phone, Clock, Mail, Instagram, Award, Calendar, Globe2, Car, Trophy, GraduationCap, ChevronLeft, ChevronRight, Play, Users, Medal, Baby, Flag } from "lucide-react";
import TrialDialog from "@/components/landing/TrialDialog";
import { LANDING } from "@/constants/testIds";

/* ===== Data ===== */
const PROFESSOR = {
  name: "Cristián Guerra",
  rank: "Cinturón Negro · Head Coach",
  img: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=1100&q=80&auto=format&fit=crop",
};

const ACHIEVEMENTS = [];  // deprecated · achievement now shown as a thin banner

const PROGRAMS = [
  {
    code: "01 / KIDS",
    title: "KIDS",
    age: "4 – 8 AÑOS",
    desc: "Aprender Jiu-Jitsu mientras desarrollan disciplina, respeto, coordinación, confianza y autocontrol. Clases dinámicas y entretenidas, diseñadas especialmente para su edad y desarrollo.",
    bullets: ["4 – 8 años", "2× por semana", "Clases dinámicas", "Grupos reducidos", "Antibullying y defensa personal"],
    cta: "Reserva tu clase de prueba",
  },
  {
    code: "02 / TEENS",
    title: "TEENS",
    age: "9 – 14 AÑOS",
    desc: "Un programa enfocado en desarrollar confianza, disciplina, condición física y seguridad personal, entregando herramientas que los acompañarán tanto dentro como fuera del tatami.",
    bullets: ["9 – 14 años", "3× por semana", "Disciplina y confianza", "Grupos reducidos", "Antibullying y defensa personal"],
    cta: "Reserva tu clase de prueba",
  },
  {
    code: "03 / STANDARD",
    title: "STANDARD",
    age: "15+ AÑOS",
    desc: "Aprende Jiu-Jitsu desde cero, mejora tu condición física, libera el estrés y desarrolla habilidades reales de defensa personal. Puedes entrenar para aprender, mantenerte activo, superarte o competir. Tú eliges tu objetivo; nosotros te ayudamos a progresar.",
    bullets: ["15+ años", "3 días a la semana", "Gi & No-Gi", "Open Mat sábados", "Plan flexible"],
    cta: "Reserva tu clase de prueba",
  },
  {
    code: "04 / FULL",
    title: "FULL",
    age: "15+ AÑOS",
    desc: "Aprende Jiu-Jitsu desde cero, mejora tu condición física, libera el estrés y desarrolla habilidades reales de defensa personal. Puedes entrenar para aprender, mantenerte activo, superarte o competir. Tú eliges tu objetivo; nosotros te ayudamos a progresar.",
    bullets: ["15+ años", "Todos los días", "Gi & No-Gi", "Open Mat sábados", "Acceso ilimitado"],
    cta: "Reserva tu clase de prueba",
  },
];

/* Schedule — based on the official timetable image */
const SCHEDULE_DAYS = ["LUN", "MAR", "MIER", "JUE", "VIE", "SÁB"];
const EMPTY = "—";
const SCHEDULE_ROWS = [
  { time: "10:00",  cells: [EMPTY, EMPTY, EMPTY, EMPTY, EMPTY, "Open Mat"] },
  { time: "12:00",  cells: ["Fundamentos", "Pro Training", "Fundamentos", "Pro Training", "Fundamentos", EMPTY] },
  { time: "17:00",  cells: ["BJJ Kids", EMPTY, "BJJ Kids", EMPTY, EMPTY, EMPTY] },
  { time: "18:00",  cells: ["BJJ Teens", "Fundamentos Grappling", "BJJ Teens", "Fundamentos Grappling", "BJJ Teens", EMPTY] },
  { time: "19:00",  cells: ["All Levels con Kimono", "All Levels Grappling", "All Levels con Kimono", "All Levels Grappling", "All Levels con Kimono", EMPTY] },
  { time: "20:30",  cells: ["Iniciantes con Kimono", "Iniciantes Grappling", "Iniciantes con Kimono", "Iniciantes Grappling", "Iniciantes con Kimono", EMPTY] },
];

/* Gallery — 12 static photos */
const GALLERY = [
  "https://images.unsplash.com/photo-1555597673-b21d5c935865?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1599058917212-d750089bc07e?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1607962837359-5e7e89f86776?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1583473848882-f9a5bc7fd2ee?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1546484959-f9a381d1330d?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1597076545399-91a3ff0e71b3?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1611042553365-9b101441c135?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1599058917212-d750089bc07e?w=1100&q=80&auto=format&fit=crop&sat=-100&blur=0",
  "https://images.unsplash.com/photo-1546483875-ad9014c88eba?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1517649763962-0c623066013b?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1605296867424-35fc25c9212a?w=1100&q=80&auto=format&fit=crop",
];

/* Photo pools for section carousels (placeholders — el cliente los reemplazará) */
const CAROUSEL_COMMUNITY = GALLERY.slice(0, 12);
const CAROUSEL_TRAJECTORY = [
  "https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1546484959-f9a381d1330d?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1599058917212-d750089bc07e?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1607962837359-5e7e89f86776?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1611042553365-9b101441c135?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1583473848882-f9a5bc7fd2ee?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1597076545399-91a3ff0e71b3?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1546483875-ad9014c88eba?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1517649763962-0c623066013b?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1605296867424-35fc25c9212a?w=1100&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1555597673-b21d5c935865?w=1100&q=80&auto=format&fit=crop",
];
const CAROUSEL_ACHIEVEMENTS = CAROUSEL_TRAJECTORY.slice().reverse();
const CAROUSEL_SEMINARS = CAROUSEL_COMMUNITY.slice().reverse();

/* Videos for the video gallery (3 vertical items · placeholders) */
const VIDEOS = Array.from({ length: 3 }).map((_, i) => ({
  id: i + 1,
  poster: GALLERY[i % GALLERY.length],
  src: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  title: `Video · Muestra ${String(i + 1).padStart(2, "0")}`,
}));

/* Google reviews (representative examples — el cliente puede reemplazar por reseñas reales) */
const REVIEWS = [
  { name: "María Fernanda C.", rating: 5, text: "Excelente escuela. El profesor Cristián tiene una vocación enorme y las clases son técnicas de verdad. Mis hijos aman las clases de Kids." },
  { name: "Rodrigo A.", rating: 5, text: "Ambiente familiar, disciplina real y un nivel técnico impresionante. Llevo un año entrenando y siento el cambio en mi vida diaria." },
  { name: "Camila S.", rating: 5, text: "Me sentí acogida desde el primer día. Recomiendo 100% la clase de prueba gratis. Muy buena energía en el tatame." },
];

/* Programs comparison table (matches user spec) */
const PLAN_COLUMNS = ["Kids", "Teens", "Grappling", "Standard", "Full", "Plan Semanal", "Pase Diario"];
const PLAN_ROWS = [
  { label: "Clases específicas por edad", values: ["4–8 años", "9–14 años", "+15 años", "+15 años", "+15 años", "+15 años", "+15 años"] },
  { label: "BJJ con Gi (Kimono)",         values: [true, true, false, true, true, true, true] },
  { label: "Grappling (No-Gi)",           values: [false, false, true, false, true, true, true] },
  { label: "Open Mat",                    values: [false, false, true, true, true, true, false] },
  { label: "Entrenamiento Competencia",   values: [false, true, true, true, true, false, false] },
  { label: "Vigencia / Acceso",           values: ["Mensual", "Mensual", "Mensual", "Mensual", "Mensual", "7 días", "1 día"] },
];

/* Class type dot colors (subtle accents, one small dot per class type) */
const CLASS_COLORS = {
  "Open Mat":                      "bg-neutral-300",
  "Fundamentos":                   "bg-sky-400",
  "Pro Training":                  "bg-red-500",
  "BJJ Kids":                      "bg-amber-400",
  "BJJ Teens":                     "bg-orange-500",
  "Fundamentos Grappling":         "bg-indigo-400",
  "All Levels con Kimono":         "bg-emerald-400",
  "All Levels Grappling":          "bg-teal-400",
  "Iniciantes con Kimono":         "bg-cyan-400",
  "Iniciantes Grappling":          "bg-purple-400",
};

/* Rules table (Etiqueta y normas) */
const RULES_GI = [
  "Uso obligatorio de Kimono blanco y Rash Guard bajo el kimono.",
  "Presentarse con el kimono lavado, limpio y en buen estado, sin manchas ni malos olores.",
  "Mantener siempre el cinturón correctamente amarrado.",
  "Llegar puntualmente a los horarios establecidos.",
  "Reserva tu lugar en la clase a través de la App Box Magic.",
  "Garantizar la higiene personal.",
  "Mantener las uñas de manos y pies cortas.",
  "Llevar una botella de agua personal (NO de vidrio).",
  "No andar descalzo fuera del tatami; utiliza sandalias o calzado adecuado en todo momento.",
  "Pedir permiso al profesor antes de entrar o salir del tatami.",
  "Guardar sus pertenencias en los casilleros de forma ordenada.",
];
const RULES_GRAPPLING = [
  "Uso obligatorio de Rash Guard y short del equipo (Rash Guard y short negro).",
  "Presentarse con el equipo de entrenamiento lavado y limpio.",
  "Llegar puntualmente a los horarios establecidos.",
  "Reserva tu lugar en la clase a través de la App Box Magic.",
  "Garantizar la higiene personal.",
  "Mantener las uñas de manos y pies cortas.",
  "Llevar una botella de agua personal (NO de vidrio).",
  "No andar descalzo fuera del tatami; usar sandalias o calzado adecuado en todo momento.",
  "Pedir permiso al profesor antes de entrar o salir del tatami.",
  "Guardar sus pertenencias en los casilleros de forma ordenada.",
];

/* ===== Shared components ===== */
function PhotoCarousel({ photos = [], testId, ariaLabel = "Galería" }) {
  const trackRef = React.useRef(null);
  const [canPrev, setCanPrev] = React.useState(false);
  const [canNext, setCanNext] = React.useState(true);

  const items = photos.slice(0, 12);

  const update = () => {
    const el = trackRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    setCanPrev(scrollLeft > 4);
    setCanNext(scrollLeft + clientWidth < scrollWidth - 4);
  };

  React.useEffect(() => {
    update();
    const el = trackRef.current;
    if (!el) return;
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    const amount = Math.round(el.clientWidth * 0.85) * (dir === "next" ? 1 : -1);
    el.scrollBy({ left: amount, behavior: "smooth" });
  };

  if (items.length === 0) return null;

  return (
    <div className="relative" aria-label={ariaLabel} data-testid={testId}>
      <div
        ref={trackRef}
        className="flex gap-3 md:gap-4 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-2 -mx-6 px-6 lg:mx-0 lg:px-0"
      >
        {items.map((src, i) => (
          <figure
            key={i}
            className="relative shrink-0 snap-start w-[240px] sm:w-[280px] md:w-[320px] aspect-[4/5] bg-neutral-100 border border-black/10 overflow-hidden"
            data-testid={`${testId}-item-${i}`}
          >
            <img
              src={src}
              alt=""
              loading="lazy"
              className="bw-img w-full h-full object-cover"
            />
            <figcaption className="pointer-events-none absolute bottom-2 left-2 font-mono-acc text-[9px] uppercase tracking-[0.2em] text-white/85 bg-black/60 px-2 py-1">
              {String(i + 1).padStart(2, "0")} / {String(items.length).padStart(2, "0")}
            </figcaption>
          </figure>
        ))}
      </div>

      {/* Controls */}
      <div className="mt-4 flex items-center justify-between gap-3">
        <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-neutral-500">
          Desliza · {items.length} fotos
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => scrollBy("prev")}
            disabled={!canPrev}
            aria-label="Anterior"
            className="btn-sharp w-10 h-10 flex items-center justify-center border border-black/20 hover:bg-black hover:text-white disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-black rounded-[2px] transition-colors"
            data-testid={`${testId}-prev`}
          >
            <ChevronLeft size={18} />
          </button>
          <button
            type="button"
            onClick={() => scrollBy("next")}
            disabled={!canNext}
            aria-label="Siguiente"
            className="btn-sharp w-10 h-10 flex items-center justify-center border border-black/20 hover:bg-black hover:text-white disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-black rounded-[2px] transition-colors"
            data-testid={`${testId}-next`}
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}

/* Same as PhotoCarousel but adapts to dark backgrounds (used inside black sections) */
function PhotoCarouselDark({ photos = [], testId, ariaLabel = "Galería" }) {
  const trackRef = React.useRef(null);
  const [canPrev, setCanPrev] = React.useState(false);
  const [canNext, setCanNext] = React.useState(true);

  const items = photos.slice(0, 12);

  const update = () => {
    const el = trackRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    setCanPrev(scrollLeft > 4);
    setCanNext(scrollLeft + clientWidth < scrollWidth - 4);
  };

  React.useEffect(() => {
    update();
    const el = trackRef.current;
    if (!el) return;
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    const amount = Math.round(el.clientWidth * 0.85) * (dir === "next" ? 1 : -1);
    el.scrollBy({ left: amount, behavior: "smooth" });
  };

  if (items.length === 0) return null;

  return (
    <div className="relative" aria-label={ariaLabel} data-testid={testId}>
      <div
        ref={trackRef}
        className="flex gap-3 md:gap-4 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-2 -mx-6 px-6 lg:mx-0 lg:px-0"
      >
        {items.map((src, i) => (
          <figure
            key={i}
            className="relative shrink-0 snap-start w-[240px] sm:w-[280px] md:w-[320px] aspect-[4/5] bg-white/5 border border-white/15 overflow-hidden"
            data-testid={`${testId}-item-${i}`}
          >
            <img
              src={src}
              alt=""
              loading="lazy"
              className="bw-img w-full h-full object-cover"
            />
            <figcaption className="pointer-events-none absolute bottom-2 left-2 font-mono-acc text-[9px] uppercase tracking-[0.2em] text-white/85 bg-black/60 px-2 py-1">
              {String(i + 1).padStart(2, "0")} / {String(items.length).padStart(2, "0")}
            </figcaption>
          </figure>
        ))}
      </div>

      <div className="mt-4 flex items-center justify-between gap-3">
        <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-white/45">
          Desliza · {items.length} fotos
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => scrollBy("prev")}
            disabled={!canPrev}
            aria-label="Anterior"
            className="btn-sharp w-10 h-10 flex items-center justify-center border border-white/25 text-white hover:bg-white hover:text-black disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-white rounded-[2px] transition-colors"
            data-testid={`${testId}-prev`}
          >
            <ChevronLeft size={18} />
          </button>
          <button
            type="button"
            onClick={() => scrollBy("next")}
            disabled={!canNext}
            aria-label="Siguiente"
            className="btn-sharp w-10 h-10 flex items-center justify-center border border-white/25 text-white hover:bg-white hover:text-black disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-white rounded-[2px] transition-colors"
            data-testid={`${testId}-next`}
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}

/* ===== Subcomponents ===== */
function NavBar({ onOpenTrial }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#historia", label: "Nosotros" },
    { href: "#profesor", label: "Profesor" },
    { href: "#clases", label: "Planes" },
    { href: "#horarios", label: "Horarios" },
    { href: "#galeria", label: "Galería" },
    { href: "#contacto", label: "Contacto" },
  ];

  return (
    <header
      data-testid={LANDING.nav}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur border-b border-black/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#top" data-testid={LANDING.navLogo} className="flex items-center gap-3 group">
          <div className={`w-8 h-8 flex items-center justify-center transition-colors ${scrolled ? "bg-black" : "bg-white"}`}>
            <span className={`font-display text-sm ${scrolled ? "text-white" : "text-black"}`}>S</span>
          </div>
          <div className="leading-none">
            <div className={`font-display text-sm tracking-tight ${scrolled ? "text-black" : "text-white"}`}>SHUN</div>
            <div className={`font-mono-acc text-[9px] uppercase tracking-[0.25em] ${scrolled ? "text-neutral-500" : "text-white/55"}`}>Jiu-Jitsu · Chile</div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-6 lg:gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`font-mono-acc text-[11px] uppercase tracking-[0.2em] transition-colors ${
                scrolled ? "text-neutral-700 hover:text-black" : "text-white/85 hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Button
            data-testid={LANDING.navCta}
            onClick={onOpenTrial}
            className={`hidden md:inline-flex btn-sharp rounded-[2px] font-mono-acc uppercase tracking-[0.18em] text-[10px] h-9 px-4 border transition-colors ${
              scrolled
                ? "bg-black text-white border-black hover:bg-neutral-800"
                : "bg-white text-black border-white hover:bg-neutral-200"
            }`}
          >
            Clase gratis
          </Button>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-[2px] border ${
              scrolled ? "border-black/15 text-black" : "border-white/40 text-white"
            }`}
            aria-label="Abrir menú"
          >
            {menuOpen ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-black/10">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setMenuOpen(false)}
                className="font-mono-acc text-xs uppercase tracking-[0.2em] py-2"
              >
                {l.label}
              </a>
            ))}
            <Button
              onClick={() => { setMenuOpen(false); onOpenTrial(); }}
              className="btn-sharp rounded-[2px] bg-black text-white hover:bg-neutral-800 font-mono-acc uppercase tracking-[0.18em] text-[11px] mt-2"
            >
              Clase gratis
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}

function Hero({ onOpenTrial }) {
  return (
    <section
      id="top"
      data-testid={LANDING.heroSection}
      className="relative bg-black text-white overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 opacity-35">
        <img
          alt="Tatami"
          src="https://images.unsplash.com/photo-1555597673-b21d5c935865?w=2000&q=80&auto=format&fit=crop"
          className="bw-img w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/40 to-black"></div>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pt-36 pb-24 md:pt-44 md:pb-32 min-h-[100vh] flex flex-col justify-between">
        {/* Top label row */}
        <div className="flex items-start justify-between rise">
          <div className="font-mono-acc text-[10px] uppercase tracking-[0.3em] text-white/60">
            / Escuela · La Serena, Coquimbo
          </div>
          <div className="hidden md:block font-mono-acc text-[10px] uppercase tracking-[0.3em] text-white/60 text-right">
            EST. 2014<br />
            <span className="text-white/30">— BRAZILIAN JIU-JITSU —</span>
          </div>
        </div>

        {/* Headline block */}
        <div className="mt-16">
          <h1
            data-testid={LANDING.heroHeadline}
            className="font-display text-[15vw] md:text-[11vw] lg:text-[10vw] leading-[0.85] tracking-[-0.045em] rise rise-1"
          >
            MASTER<br />
            <span className="text-white/40">THE</span> ART.
          </h1>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
            <p className="md:col-span-5 md:col-start-1 text-white/70 text-base md:text-lg max-w-md rise rise-2">
              Una escuela donde la técnica clásica de Brazilian Jiu-Jitsu se entrena con disciplina, paciencia y comunidad.
            </p>

            <div className="md:col-span-6 md:col-start-7 flex flex-wrap gap-3 rise rise-3">
              <Button
                data-testid={LANDING.heroCta}
                onClick={onOpenTrial}
                className="btn-sharp rounded-[2px] bg-white text-black hover:bg-neutral-200 font-mono-acc uppercase tracking-[0.18em] text-[11px] h-12 px-5"
              >
                Reservar clase GRATIS
                <ArrowUpRight size={15} className="ml-2" />
              </Button>
              <a
                data-testid={LANDING.heroSecondaryCta}
                href="#horarios"
                className="btn-sharp inline-flex items-center rounded-[2px] border border-white/30 hover:border-white hover:bg-white/5 text-white font-mono-acc uppercase tracking-[0.18em] text-[11px] h-12 px-5 transition-colors"
              >
                Ver horarios
              </a>
              <a
                data-testid="hero-cta-planes"
                href="#clases"
                className="btn-sharp inline-flex items-center rounded-[2px] border border-white/30 hover:border-white hover:bg-white/5 text-white font-mono-acc uppercase tracking-[0.18em] text-[11px] h-12 px-5 transition-colors"
              >
                Ver planes
              </a>
            </div>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 rise rise-4">
          {[
            ["GI (KIMONO) / GRAPPLING", "AMBOS FORMATOS"],
            ["KIDS · TEENS · ADULTOS", "TODOS LOS NIVELES"],
            ["L–V 12:00 / 21:30", "SÁB · OPEN MAT 10:00"],
          ].map(([a, b]) => (
            <div key={a} className="bg-black p-5">
              <div className="font-mono-acc text-[10px] uppercase tracking-[0.2em] text-white">{a}</div>
              <div className="font-mono-acc text-[10px] uppercase tracking-[0.2em] text-white/40 mt-1">{b}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Marquee strip */}
      <div className="border-y border-white/10 bg-black overflow-hidden no-scrollbar">
        <div className="marquee-track flex whitespace-nowrap py-4">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center gap-12 px-6 font-mono-acc text-xs uppercase tracking-[0.3em] text-white/50">
              <span>Brazilian Jiu-Jitsu</span><span>·</span>
              <span>Disciplina</span><span>·</span>
              <span>Linaje</span><span>·</span>
              <span>Técnica</span><span>·</span>
              <span>Comunidad</span><span>·</span>
              <span>La Serena · Chile</span><span>·</span>
              <span>Shun Academy</span><span>·</span>
              <span>Est. 2014</span><span>·</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Story() {
  const highlights = [
    { icon: Calendar, text: "Más de una década de trayectoria en La Serena." },
    { icon: Award,    text: "Escuela certificada internacionalmente por la IBJJF." },
    { icon: Globe2,   text: "Conexión directa con la escuela Barbosa Jiu-Jitsu (Brasil) y el Sensei Carlos Ferreira de la escuela SHUN en Brasil." },
    { icon: Car,      text: "Ubicación estratégica en La Serena con excelente acceso y estacionamiento privado." },
  ];

  return (
    <section
      id="historia"
      data-testid={LANDING.storySection}
      className="bg-white py-20 md:py-28 border-t border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Centered heading */}
        <div className="max-w-4xl mx-auto text-center">
          <div className="font-mono-acc text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-6">
            / 01 — Nosotros
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-[-0.04em] leading-[0.98]">
            Jiu-Jitsu de calidad por personas de calidad.
          </h2>
          <div className="mt-8 inline-flex items-center gap-3 font-mono-acc text-[10px] uppercase tracking-[0.25em] text-neutral-600 border border-black/15 px-3 py-2">
            <span className="w-1.5 h-1.5 bg-black"></span>
            Certificación IBJJF
          </div>
        </div>

        {/* Centered body copy */}
        <div className="mt-14 max-w-4xl mx-auto text-center space-y-5">
          <p className="text-base md:text-lg leading-relaxed text-neutral-800">
            Con más de <strong className="font-semibold">10 años de trayectoria en La Serena</strong>,
            en Shun Jiu-Jitsu Chile nos dedicamos a enseñar Brazilian Jiu-Jitsu con un
            alto estándar técnico, una metodología estructurada y una formación basada
            en el respeto, la disciplina y el compañerismo.
          </p>
          <p className="text-base md:text-lg leading-relaxed text-neutral-800">
            Nuestra escuela cuenta con programas para
            <strong className="font-semibold"> niños, jóvenes y adultos</strong>, adaptados a
            cada etapa y nivel de experiencia. Desde quienes comienzan por primera vez
            hasta alumnos avanzados, cada persona encuentra un espacio donde puede
            aprender, progresar y desarrollar sus capacidades a su propio ritmo.
          </p>
          <p className="text-base md:text-lg leading-relaxed text-neutral-800">
            En nuestras clases podrás aprender <strong className="font-semibold">Jiu-Jitsu con kimono (Gi)</strong>,
            {" "}<strong className="font-semibold">Grappling (No-Gi)</strong> y defensa personal,
            mientras mejoras tu condición física, desarrollas confianza, liberas el
            estrés y compartes con una comunidad unida por las ganas de aprender y
            superarse.
          </p>
          <p className="text-base md:text-lg leading-relaxed text-neutral-800">
            Nuestra enseñanza es el resultado de años de experiencia, formación
            constante y trabajo dentro y fuera del tatami. Una metodología que continúa
            evolucionando a través del estudio, el entrenamiento y la experiencia
            nacional e internacional, siempre con un objetivo claro: entregar a nuestros
            alumnos una enseñanza <strong className="font-semibold">actualizada, técnica y de calidad</strong>.
          </p>
          <p className="text-base md:text-lg leading-relaxed text-neutral-800">
            Ya sea que busques aprender una nueva disciplina, mejorar tu condición
            física, desarrollar herramientas de defensa personal, superarte o llevar
            tu nivel a la competencia, encontrarás una metodología y un equipo
            preparado para acompañarte en ese proceso.
          </p>
          <p className="text-base md:text-lg leading-relaxed text-neutral-900 font-medium">
            Más que un lugar para entrenar, somos una escuela donde puedes aprender,
            disfrutar, progresar y formar parte de una comunidad.
          </p>
        </div>

        {/* 4 highlights in a SINGLE row */}
        <ul className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-200 border border-neutral-200">
          {highlights.map((h, i) => {
            const Icon = h.icon;
            return (
              <li key={i} className="flex flex-col bg-white p-6 min-h-[168px]">
                <span className="shrink-0 w-11 h-11 border border-black/15 flex items-center justify-center mb-4">
                  <Icon size={18} strokeWidth={1.6} />
                </span>
                <p className="text-sm leading-relaxed text-neutral-800">{h.text}</p>
              </li>
            );
          })}
        </ul>

        {/* Community photo carousel */}
        <div className="mt-16">
          <PhotoCarousel photos={CAROUSEL_COMMUNITY} testId="carousel-community" ariaLabel="Fotos de la comunidad Shun" />
        </div>
      </div>

      {/* Black featured block: newcomer welcome — full bleed, centered */}
      <div
        className="mt-20 md:mt-24 bg-black text-white w-full"
        data-testid="newcomer-block"
      >
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16 md:py-24 text-center">
          <h3 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-[-0.03em] leading-[1.05]">
            ¿Nunca has entrenado Jiu-Jitsu?<br />
            <span className="text-white/60">¡Estás en el lugar indicado!</span>
          </h3>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-white/85">
            No necesitas experiencia previa para comenzar. Nuestras clases están
            diseñadas para que aprendas paso a paso, de manera segura y a tu propio
            ritmo, acompañado por profesores que estarán presentes durante todo tu
            proceso.
          </p>
          <p className="mt-4 text-base md:text-lg leading-relaxed text-white/85">
            Desde el primer día encontrarás un ambiente respetuoso, cercano y
            profesional, donde podrás aprender, entrenar y disfrutar sin importar
            tu nivel.
          </p>
          <p className="mt-4 text-base md:text-lg leading-relaxed text-white font-medium">
            Y para que solo tengas que preocuparte de comenzar, te
            <span className="underline decoration-2 underline-offset-[6px]"> prestamos el kimono</span>
            {" "}para tu primera clase.
          </p>
        </div>
      </div>
    </section>
  );
}

function Professor() {
  return (
    <section
      id="profesor"
      data-testid={LANDING.instructorsSection}
      className="bg-white py-20 md:py-28 border-t border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="font-mono-acc text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-4">
          / 02 — Profesor
        </div>
        <h2 className="font-display text-5xl md:text-6xl lg:text-7xl tracking-[-0.04em] leading-[0.95] mb-16">
          Conoce al profesor.
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          {/* Photo */}
          <div
            className="lg:col-span-5 relative aspect-[4/5] overflow-hidden bg-neutral-100 border border-black/10"
            data-testid={LANDING.instructorCard}
          >
            <img
              src={PROFESSOR.img}
              alt={PROFESSOR.name}
              className="bw-img w-full h-full object-cover"
            />
            <div className="absolute top-4 left-4 font-mono-acc text-[10px] uppercase tracking-[0.2em] bg-white text-black px-3 py-1.5">
              {PROFESSOR.rank}
            </div>
            <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
              <div className="font-display text-3xl md:text-4xl tracking-[-0.03em] text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]">
                {PROFESSOR.name}
              </div>
              <div className="font-mono-acc text-[9px] uppercase tracking-[0.25em] text-white/90">
                LA SERENA · CL
              </div>
            </div>
          </div>

          {/* Bio */}
          <div className="lg:col-span-7">
            <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-3">
              Head Coach · Shun Jiu-Jitsu Chile
            </div>
            <h3 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-[-0.04em] leading-[0.98] mb-4">
              Cristián Guerra
            </h3>
            <p className="font-mono-acc text-[11px] uppercase tracking-[0.2em] text-neutral-600 mb-8">
              Cinturón Negro · Fundador y Profesor de Shun Jiu-Jitsu Chile
            </p>

            <p className="text-base md:text-lg leading-relaxed text-neutral-800">
              Con más de <strong className="font-semibold">una década dedicada al Jiu-Jitsu</strong>,
              Cristián Guerra ha construido su trayectoria combinando formación técnica,
              docencia y experiencia competitiva nacional e internacional.
            </p>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-neutral-700">
              Formado bajo la guía del reconocido
              <strong className="font-semibold"> Sensei Carlos Ferreira (Shun)</strong>,
              ha complementado constantemente su preparación entrenando en
              <strong className="font-semibold"> Brasil, Australia</strong> y junto a profesores y academias de
              reconocido nivel internacional. Como competidor, ha participado en
              importantes campeonatos, alcanzando entre sus resultados el
              <strong className="font-semibold"> 3.er lugar en el Campeonato Mundial CBJJE</strong>.
            </p>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-neutral-700">
              Toda esa experiencia tiene un propósito:
              <strong className="font-semibold"> entregar una enseñanza de calidad a cada alumno</strong>
              {" "}que entra a la escuela.
            </p>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-neutral-700">
              Su metodología se basa en una enseñanza técnica clara, progresiva y
              cercana, entendiendo que cada persona llega al Jiu-Jitsu con objetivos
              diferentes.
            </p>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-neutral-700">
              Desde quien pisa un tatami por primera vez hasta quien busca competir al
              más alto nivel, el compromiso es el mismo: ayudar a cada alumno a
              aprender, progresar y desarrollar su mejor versión a través del Jiu-Jitsu.
            </p>
          </div>
        </div>

        {/* Trajectory carousel */}
        <div className="mt-16">
          <PhotoCarousel photos={CAROUSEL_TRAJECTORY} testId="carousel-trajectory" ariaLabel="Fotos de la trayectoria del profesor" />
        </div>
      </div>
    </section>
  );
}

function LogrosSection({ onOpenTrial }) {
  const stats = [
    { icon: Award,    n: "01",   l: "Cinturón Negro" },
    { icon: Medal,    n: "+50",  l: "Medallas" },
    { icon: Users,    n: "+150", l: "Alumnos activos" },
    { icon: Baby,     n: "Kids", l: "Programa infantil" },
    { icon: Flag,     n: "+15",  l: "Competidores internacionales" },
  ];

  return (
    <section
      id="logros"
      data-testid={LANDING.achievementsSection}
      className="bg-black text-white py-20 md:py-28"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">

        {/* Center-justified featured phrase */}
        <p className="font-display text-3xl md:text-4xl lg:text-5xl tracking-[-0.03em] leading-[1.05] max-w-5xl mx-auto text-center">
          Somos la <span className="text-white/55">primera escuela de la región</span> en
          conseguir un <span className="underline decoration-2 underline-offset-[8px]">doble oro</span> en el prestigioso
          {" "}Campeonato Brasileiro 2026 de la CBJJ en <span className="text-white/85">São Paulo</span>.
        </p>

        <div className="mt-8 flex justify-center">
          <div className="inline-flex items-center gap-3 font-mono-acc text-[10px] uppercase tracking-[0.3em] text-white/55 border border-white/20 px-3 py-2">
            <Trophy size={12} />
            CBJJ · São Paulo, Brasil · 2026
          </div>
        </div>

        {/* Carousel */}
        <div className="mt-16">
          <PhotoCarouselDark photos={CAROUSEL_ACHIEVEMENTS} testId="carousel-achievements" ariaLabel="Fotos de los logros" />
        </div>

        {/* 5 highlighted rectangles in a single row */}
        <ul className="mt-16 grid grid-cols-2 md:grid-cols-5 gap-px bg-white/10 border border-white/10">
          {stats.map((s) => {
            const Icon = s.icon;
            return (
              <li key={s.l} className="bg-black p-6 flex flex-col gap-4 min-h-[180px]">
                <span className="w-10 h-10 border border-white/25 flex items-center justify-center">
                  <Icon size={18} strokeWidth={1.6} />
                </span>
                <div>
                  <div className="font-display text-3xl md:text-4xl tracking-[-0.03em] leading-none">
                    {s.n}
                  </div>
                  <div className="mt-2 font-mono-acc text-[10px] uppercase tracking-[0.2em] text-white/60">
                    {s.l}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>

        <div className="mt-8 text-center">
          <button
            onClick={onOpenTrial}
            className="btn-sharp inline-flex items-center gap-3 rounded-[2px] bg-white text-black hover:bg-neutral-200 font-mono-acc uppercase tracking-[0.18em] text-[11px] h-12 px-6"
          >
            Únete a la escuela
            <ArrowUpRight size={15} />
          </button>
        </div>
      </div>
    </section>
  );
}

function CampamentosSection() {
  return (
    <section
      id="campamentos"
      data-testid="section-campamentos"
      className="bg-white py-20 md:py-28 border-t border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-[-0.04em] leading-[0.98]">
            Jiu-Jitsu <span className="text-neutral-400">internacional</span> directo en nuestro tatami.
          </h2>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-neutral-800 max-w-3xl mx-auto">
            En nuestra escuela organizamos continuamente clases y seminarios con
            <strong className="font-semibold"> profesores e instructores internacionales de primer nivel</strong>.
            Un espacio donde nuestros alumnos acceden a técnicas de vanguardia,
            perfeccionan su Jiu-Jitsu directamente de la mano de referentes globales
            y viven la experiencia del <strong className="font-semibold">tatame internacional</strong>.
          </p>
        </div>

        {/* Seminars carousel */}
        <div className="mt-14">
          <PhotoCarousel photos={CAROUSEL_SEMINARS} testId="carousel-seminars" ariaLabel="Fotos de campamentos y seminarios" />
        </div>
      </div>
    </section>
  );
}

function PlanCell({ v }) {
  if (v === true) return <span aria-label="incluido" className="inline-block text-emerald-600 font-semibold text-lg">✓</span>;
  if (v === false) return <span aria-label="no incluido" className="inline-block text-neutral-300 font-semibold text-lg">✕</span>;
  return <span className="font-mono-acc text-[10px] md:text-[11px] uppercase tracking-[0.14em] text-black">{v}</span>;
}

function Programs({ onOpenTrial, setProgramChoice }) {
  return (
    <section
      id="clases"
      data-testid={LANDING.programsSection}
      className="bg-white pt-20 md:pt-24"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
          <div>
            <div className="font-mono-acc text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-4">
              / 05 — Planes
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl tracking-[-0.03em] leading-[0.95]">
              Planes para todas las edades.
            </h2>
          </div>
        </div>

        {/* 4-card layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="programs-grid">
          {PROGRAMS.map((p) => (
            <article
              key={p.title}
              data-testid={LANDING.programCard}
              className="border border-black/15 rounded-[4px] p-6 md:p-7 flex flex-col bg-white hover:border-black transition-colors duration-300"
            >
              <div className="flex items-start justify-between mb-8">
                <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-neutral-500">
                  {p.code}
                </div>
                <div className="font-mono-acc text-[10px] uppercase tracking-[0.2em] text-black border border-black/20 px-2 py-1">
                  {p.age}
                </div>
              </div>

              <h3 className="font-display text-4xl md:text-5xl tracking-[-0.03em] mb-5">{p.title}</h3>
              <p className="text-sm text-neutral-600 leading-relaxed mb-7">{p.desc}</p>

              <ul className="space-y-3 mb-8">
                {p.bullets.map((b) => (
                  <li key={b} className="flex items-center gap-3 text-sm">
                    <span className="block w-2 h-2 bg-black shrink-0"></span>
                    <span className="text-neutral-800">{b}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => { setProgramChoice(p.title); onOpenTrial(); }}
                className="btn-sharp mt-auto inline-flex items-center justify-between border border-black px-4 py-3.5 hover:bg-black hover:text-white font-mono-acc uppercase tracking-[0.18em] text-[10px] rounded-[2px]"
              >
                <span>{p.cta}</span>
                <ArrowUpRight size={14} />
              </button>
            </article>
          ))}
        </div>
      </div>

      {/* Short-term access box — full-bleed gray, centered */}
      <aside
        data-testid="short-term-box"
        className="mt-16 md:mt-20 bg-white w-full"
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 md:py-20 text-center">
          <h3 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-[-0.03em] leading-[1.05] max-w-3xl mx-auto">
            Prueba nuestras clases por un día o una semana.
          </h3>

          <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-px bg-neutral-300 border border-neutral-300 max-w-3xl mx-auto text-left">
            <li className="bg-white p-6">
              <div className="font-mono-acc text-[10px] uppercase tracking-[0.2em] text-neutral-500 mb-3">01 / Pase Diario</div>
              <div className="font-display text-2xl tracking-[-0.025em] leading-tight">Entrenamiento de una jornada.</div>
            </li>
            <li className="bg-white p-6">
              <div className="font-mono-acc text-[10px] uppercase tracking-[0.2em] text-neutral-500 mb-3">02 / Plan Semanal</div>
              <div className="font-display text-2xl tracking-[-0.025em] leading-tight">Acceso ilimitado por 7 días.</div>
            </li>
          </ul>

          <p className="mt-8 text-sm text-neutral-700 leading-relaxed max-w-xl mx-auto">
            Consulta disponibilidad y valores especiales escribiéndonos directamente a nuestro WhatsApp.
          </p>

          <a
            href="https://wa.me/56941597270?text=Hola%20Shun%20Jiu-Jitsu%2C%20quiero%20consultar%20por%20el%20Pase%20Diario%20%2F%20Plan%20Semanal."
            target="_blank"
            rel="noopener noreferrer"
            data-testid="short-term-wa-cta"
            className="btn-sharp mt-6 inline-flex items-center gap-3 rounded-[2px] bg-black text-white hover:bg-neutral-800 font-mono-acc uppercase tracking-[0.18em] text-[11px] h-12 px-6"
          >
            Consultar por WhatsApp
            <ArrowUpRight size={15} />
          </a>
        </div>
      </aside>

      {/* Full-bleed CTA banner · Tu primera clase es GRATIS */}
      <div className="bg-neutral-100 text-black w-full" data-testid="plans-cta-banner">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 md:py-24 flex flex-col md:flex-row md:items-center md:justify-between gap-10">
          <div className="flex-1">
            <p className="font-display text-4xl md:text-6xl lg:text-7xl tracking-[-0.035em] leading-[0.95]">
              Tu primera clase<br className="hidden md:block" />
              es <span className="underline decoration-[3px] underline-offset-[10px]">GRATIS</span>.
            </p>
            <p className="mt-6 text-sm md:text-base text-neutral-600 max-w-lg">
              Ven a probar una clase con nosotros. Sin compromiso, sin costo.
              Solo trae ropa cómoda y ganas de entrenar.
            </p>
          </div>
          <button
            data-testid="plans-cta-trial"
            onClick={onOpenTrial}
            className="btn-sharp inline-flex items-center gap-3 rounded-[2px] bg-black text-white hover:bg-neutral-800 font-mono-acc uppercase tracking-[0.18em] text-xs md:text-sm h-14 md:h-16 px-7 md:px-8 self-start md:self-auto shrink-0"
          >
            Reservar tu clase de prueba
            <ArrowUpRight size={18} />
          </button>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 md:pt-24 pb-20 md:pb-28">
        {/* Google reviews */}
        <div>
          <div className="mb-8 flex items-end justify-between flex-wrap gap-3">
            <div>
              <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-2">
                / Reseñas
              </div>
              <h3 className="font-display text-3xl md:text-4xl tracking-[-0.03em]">
                Lo que dice nuestra comunidad.
              </h3>
            </div>
            <a
              href="https://www.google.com/search?q=Shun+Jiu-Jitsu+Chile+La+Serena"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono-acc text-[10px] uppercase tracking-[0.2em] text-neutral-600 hover:text-black inline-flex items-center gap-2"
            >
              Ver todas <ArrowUpRight size={12} />
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="reviews-grid">
            {REVIEWS.map((r) => (
              <article
                key={r.name}
                data-testid="review-card"
                className="border border-black/12 p-6 flex flex-col rounded-[2px] bg-white"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="font-mono-acc text-[11px] tracking-[0.1em] text-black">
                    {"★".repeat(r.rating)}
                    <span className="text-neutral-300">{"★".repeat(5 - r.rating)}</span>
                  </div>
                  <div className="font-mono-acc text-[9px] uppercase tracking-[0.2em] text-neutral-500">Google</div>
                </div>
                <p className="text-sm leading-relaxed text-neutral-800 flex-1">“{r.text}”</p>
                <div className="mt-5 pt-4 border-t border-black/10 font-mono-acc text-[10px] uppercase tracking-[0.2em] text-neutral-600">
                  — {r.name}
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function Gallery() {
  const [activeVideo, setActiveVideo] = React.useState(null);

  return (
    <section
      id="galeria"
      data-testid={LANDING.gallerySection}
      className="bg-white py-20 md:py-28 border-t border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
          <div>
            <div className="font-mono-acc text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-4">
              / 07 — Galería
            </div>
            <h2 className="font-display text-5xl md:text-6xl tracking-[-0.03em] leading-[0.95]">
              El tatami, en movimiento.
            </h2>
          </div>
        </div>

        {/* 3 vertical videos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 max-w-5xl mx-auto" data-testid="video-grid">
          {VIDEOS.map((v) => (
            <button
              key={v.id}
              type="button"
              onClick={() => setActiveVideo(v)}
              className="group relative overflow-hidden bg-neutral-900 border border-black/10 aspect-[9/16] text-left rounded-[2px]"
              data-testid={`video-item-${v.id}`}
              aria-label={`Reproducir ${v.title}`}
            >
              <img
                src={v.poster}
                alt=""
                loading="lazy"
                className="bw-img w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/25 group-hover:bg-black/15 transition-colors" />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/95 group-hover:bg-white flex items-center justify-center transition-all duration-300 group-hover:scale-105">
                  <Play size={22} className="text-black ml-1" fill="currentColor" />
                </span>
              </div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                <span className="font-mono-acc text-[10px] uppercase tracking-[0.2em] text-white/90 bg-black/60 px-2 py-1">
                  {v.title}
                </span>
                <span className="font-mono-acc text-[10px] uppercase tracking-[0.2em] text-white/70 bg-black/60 px-2 py-1">
                  {String(v.id).padStart(2, "0")} / 03
                </span>
              </div>
            </button>
          ))}
        </div>

        {/* Video dialog */}
        <Dialog open={!!activeVideo} onOpenChange={(v) => !v && setActiveVideo(null)}>
          <DialogContent
            data-testid="video-dialog"
            className="max-w-md w-[95vw] p-0 border border-black/20 rounded-[4px] bg-black overflow-hidden"
          >
            <DialogTitle className="sr-only">{activeVideo?.title || "Video"}</DialogTitle>
            <div className="relative aspect-[9/16] bg-black">
              {activeVideo && (
                <video
                  key={activeVideo.id}
                  src={activeVideo.src}
                  controls
                  autoPlay
                  className="w-full h-full"
                  poster={activeVideo.poster}
                />
              )}
            </div>
            <div className="p-4 bg-black text-white flex items-center justify-between">
              <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-white/70">
                {activeVideo?.title}
              </div>
              <button
                onClick={() => setActiveVideo(null)}
                className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-white/80 hover:text-white"
                data-testid="video-dialog-close"
              >
                Cerrar ✕
              </button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Etiqueta y reglas de la escuela */}
        <div className="mt-16" data-testid="rules-section">
          <div className="mb-8">
            <div className="font-mono-acc text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-3">
              / Reglamento
            </div>
            <h3 className="font-display text-4xl md:text-5xl tracking-[-0.03em] leading-[0.95]">
              Etiqueta y reglas de la escuela.
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-black border border-black">
            <div className="bg-white p-8" data-testid="rules-gi">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-black/10">
                <span className="w-9 h-9 border border-black/20 flex items-center justify-center font-mono-acc text-[10px] tracking-[0.15em] uppercase">GI</span>
                <h4 className="font-display text-xl md:text-2xl tracking-[-0.02em]">
                  Etiqueta y normas · Con Kimono
                </h4>
              </div>
              <ul className="space-y-3">
                {RULES_GI.map((r, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-neutral-800 leading-relaxed">
                    <span className="block w-1.5 h-1.5 bg-black mt-2 shrink-0"></span>
                    <span>{r}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white p-8" data-testid="rules-grappling">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-black/10">
                <span className="w-9 h-9 bg-black text-white flex items-center justify-center font-mono-acc text-[10px] tracking-[0.15em] uppercase">NG</span>
                <h4 className="font-display text-xl md:text-2xl tracking-[-0.02em]">
                  Etiqueta y normas · Grappling
                </h4>
              </div>
              <ul className="space-y-3">
                {RULES_GRAPPLING.map((r, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-neutral-800 leading-relaxed">
                    <span className="block w-1.5 h-1.5 bg-black mt-2 shrink-0"></span>
                    <span>{r}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Schedule() {
  return (
    <section
      id="horarios"
      data-testid={LANDING.scheduleSection}
      className="bg-black text-white py-20 md:py-28"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-12">
          <div className="font-mono-acc text-[10px] uppercase tracking-[0.3em] text-white/50 mb-4">
            / 06 — Horarios
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl tracking-[-0.04em] leading-[0.95]">
            Encuentra tu clase.
          </h2>
          <p className="mt-5 text-sm md:text-base text-white/70 max-w-2xl leading-relaxed">
            Clases disponibles de lunes a sábado para todas las edades y niveles.
          </p>
        </div>

        {/* Legend · color dots per class type */}
        <div className="mb-6 flex flex-wrap gap-x-6 gap-y-3" data-testid="schedule-legend">
          {Object.entries(CLASS_COLORS).map(([label, color]) => (
            <div key={label} className="inline-flex items-center gap-2 font-mono-acc text-[10px] uppercase tracking-[0.15em] text-white/70">
              <span className={`inline-block w-2.5 h-2.5 rounded-full ${color}`} />
              {label}
            </div>
          ))}
        </div>

        {/* True table — 6 days × 6 time slots */}
        <div className="overflow-x-auto no-scrollbar -mx-6 lg:mx-0">
          <table className="w-full min-w-[820px] border-collapse">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="text-left py-4 px-4 w-[110px] font-mono-acc text-[11px] uppercase tracking-[0.25em] text-black bg-white"
                >
                  HORA
                </th>
                {SCHEDULE_DAYS.map((d) => (
                  <th
                    key={d}
                    scope="col"
                    className="text-center py-4 px-3 font-mono-acc text-[11px] uppercase tracking-[0.25em] text-black bg-white border-l border-black/15"
                  >
                    {d}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {SCHEDULE_ROWS.map((row, rIdx) => (
                <tr
                  key={row.time}
                  data-testid={LANDING.scheduleRow}
                  className={`border-t border-white/12 ${rIdx % 2 === 0 ? "bg-white/[0.02]" : "bg-transparent"} hover:bg-white/[0.05] transition-colors`}
                >
                  <th
                    scope="row"
                    className="text-left py-6 px-4 font-display text-2xl md:text-3xl tracking-tight align-middle"
                  >
                    {row.time}
                  </th>
                  {row.cells.map((cell, i) => {
                    const empty = cell === EMPTY;
                    const color = CLASS_COLORS[cell] || null;
                    return (
                      <td
                        key={i}
                        className={`py-6 px-3 align-middle text-center border-l border-white/10 ${
                          empty
                            ? "font-display text-2xl text-white/20"
                            : "font-mono-acc text-[10px] md:text-[11px] uppercase tracking-[0.18em] text-white leading-snug"
                        }`}
                      >
                        {empty ? (
                          EMPTY
                        ) : (
                          <span className="inline-flex items-center gap-2">
                            {color && <span className={`inline-block w-2 h-2 rounded-full ${color}`} />}
                            <span>{cell}</span>
                          </span>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-6 font-mono-acc text-[10px] uppercase tracking-[0.25em] text-white/40">
          * Domingo · cerrado · Av. Balmaceda 3070, L12 · La Serena.
        </div>
      </div>
    </section>
  );
}

function Location({ onOpenTrial }) {
  return (
    <section
      id="contacto"
      data-testid={LANDING.locationSection}
      className="bg-white pt-10 md:pt-14 pb-20 md:pb-28"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <h2 className="font-display text-5xl md:text-6xl tracking-tight mb-16">
          Nuestra ubicación.
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Map · Google Maps embed (monochrome via CSS) */}
          <div className="lg:col-span-7 relative aspect-[16/11] border border-black/10 overflow-hidden bg-neutral-100">
            <iframe
              title="Ubicación Shun Jiu-Jitsu Chile"
              src="https://www.google.com/maps?q=Av.+Balmaceda+3070,+La+Serena,+Coquimbo,+Chile&hl=es&z=17&output=embed"
              width="100%"
              height="100%"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
              style={{ border: 0, filter: "grayscale(100%) contrast(1.05)" }}
            />
            <div className="pointer-events-none absolute top-4 right-4 font-mono-acc text-[10px] uppercase tracking-[0.2em] text-black bg-white/95 px-2 py-1 border border-black/10">
              MAP · LA SERENA
            </div>
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Av.+Balmaceda+3070,+La+Serena,+Coquimbo,+Chile"
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-4 left-4 font-mono-acc text-[10px] uppercase tracking-[0.2em] text-white bg-black px-3 py-2 hover:bg-neutral-800 transition-colors"
              data-testid="map-directions-link"
            >
              ↗ Cómo llegar
            </a>
          </div>

          {/* Info */}
          <div className="lg:col-span-5 flex flex-col">
            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4 border-t border-black/10 pt-6">
                <MapPin size={18} className="mt-0.5 shrink-0" />
                <div>
                  <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-1">Dirección</div>
                  <div className="text-base">Av. Balmaceda 3070, L12</div>
                  <div className="text-sm text-neutral-600">1710534 — La Serena, Coquimbo</div>
                </div>
              </div>

              <div className="flex items-start gap-4 border-t border-black/10 pt-6">
                <Phone size={18} className="mt-0.5 shrink-0" />
                <div>
                  <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-1">WhatsApp</div>
                  <a href="https://wa.me/56941597270" target="_blank" rel="noopener noreferrer" className="text-base hover:underline">
                    +56 9 4159 7270
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 border-t border-black/10 pt-6">
                <Clock size={18} className="mt-0.5 shrink-0" />
                <div>
                  <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-1">Horario</div>
                  <div className="text-sm leading-relaxed">
                    Lunes a Viernes — 11:00 / 22:00<br />
                    Sábado — 10:00 / 13:00<br />
                    <span className="text-neutral-500">Domingo · Cerrado</span>
                  </div>
                </div>
              </div>
            </div>

            <Button
              onClick={onOpenTrial}
              className="btn-sharp rounded-[2px] bg-black text-white hover:bg-neutral-800 font-mono-acc uppercase tracking-[0.18em] text-xs h-12 px-6 self-start"
            >
              Reserva tu prueba gratis
              <ArrowUpRight size={16} className="ml-2" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer
      data-testid={LANDING.footerSection}
      className="bg-black text-white pt-20 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-5">
            <div className="font-display text-4xl md:text-5xl tracking-tight leading-[0.95]">
              SHUN<br />
              <span className="text-white/30">JIU-JITSU CHILE.</span>
            </div>
            <p className="mt-6 text-sm text-white/60 max-w-sm">
              Comunidad, profesionalismo y valores.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">Navegación</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#historia" className="hover:text-white text-white/70">Nosotros</a></li>
              <li><a href="#profesor" className="hover:text-white text-white/70">Profesor</a></li>
              <li><a href="#clases" className="hover:text-white text-white/70">Planes</a></li>
              <li><a href="#horarios" className="hover:text-white text-white/70">Horarios</a></li>
              <li><a href="#galeria" className="hover:text-white text-white/70">Galería</a></li>
              <li><a href="#contacto" className="hover:text-white text-white/70">Contacto</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">Contacto</div>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2 text-white/70"><MapPin size={14} /> Av. Balmaceda 3070, L12 · La Serena</li>
              <li className="flex items-center gap-2 text-white/70"><Phone size={14} /> +56 9 4159 7270</li>
              <li className="flex items-center gap-2 text-white/70"><Mail size={14} /> hola@shunjiujitsu.cl</li>
              <li className="flex items-center gap-2 text-white/70"><Instagram size={14} /> @shunjiujitsu.cl</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/15 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-white/40">
            © {new Date().getFullYear()} Shun Jiu-Jitsu Chile · Todos los derechos reservados
          </div>
          <div className="font-mono-acc text-[10px] uppercase tracking-[0.25em] text-white/40">
            La Serena · Coquimbo · Chile
          </div>
        </div>
      </div>
    </footer>
  );
}

/* ===== Page ===== */
export default function LandingPage() {
  const [trialOpen, setTrialOpen] = useState(false);
  const [programChoice, setProgramChoice] = useState("");

  const openTrial = () => setTrialOpen(true);

  return (
    <div className="bg-white text-black">
      <NavBar onOpenTrial={openTrial} />
      <Hero onOpenTrial={openTrial} />
      <Story />
      <Professor />
      <LogrosSection onOpenTrial={openTrial} />
      <CampamentosSection />
      <Programs onOpenTrial={openTrial} setProgramChoice={setProgramChoice} />
      <Schedule />
      <Gallery />
      <Location onOpenTrial={openTrial} />
      <Footer />
      <TrialDialog
        open={trialOpen}
        onOpenChange={(v) => { setTrialOpen(v); if (!v) setProgramChoice(""); }}
        defaultProgram={programChoice}
      />
    </div>
  );
}
